import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, unref as _unref, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from './img/banner.jpg';
import _imports_1 from './img/advantage/认证icon.svg';
import _imports_2 from './img/advantage/用户icon.svg';
import _imports_3 from './img/advantage/获客icon.svg';
import _imports_4 from './img/advantage/省心icon.svg';
import _imports_5 from './img/advantage/风险icon.svg';
import _imports_6 from './img/advantage/保障icon.svg';
import _imports_7 from './img/医保代办流程.png';
const _withScopeId = n => (_pushScopeId("data-v-0891c71c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "medicare_wrap"
};
const _hoisted_2 = {
  class: "banner_wrap"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_4 = {
  class: "banner_text"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "info"
}, [/*#__PURE__*/_createTextVNode("保达科技提供"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode("医保代办申请全流程服务")], -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content"
}, "目前可提供代办服务城市：广州、佛山、珠海", -1));
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"title\" data-v-0891c71c>申请医保的优势在哪里</div><div class=\"advantage_content\" data-v-0891c71c><div class=\"item\" data-v-0891c71c><div class=\"item_text\" data-v-0891c71c><div class=\"title\" data-v-0891c71c>提升机构公信力</div><div class=\"desc\" data-v-0891c71c>医保申请是经过相关部门综合评估之后才成为定点医疗机构，是受国家权威认可，更受患者的认可和信赖，患者就诊购药更放心</div></div><div class=\"item_img\" data-v-0891c71c><img src=\"" + _imports_1 + "\" alt=\"\" data-v-0891c71c></div></div><div class=\"item\" data-v-0891c71c><div class=\"item_text\" data-v-0891c71c><div class=\"title\" data-v-0891c71c>增强客户粘性</div><div class=\"desc\" data-v-0891c71c>满足客户就诊服务外，通过医保被动引流提升整体医疗服务和医疗质量，形成良性口碑增强患者粘性</div></div><div class=\"item_img\" data-v-0891c71c><img src=\"" + _imports_2 + "\" alt=\"\" data-v-0891c71c></div></div><div class=\"item\" data-v-0891c71c><div class=\"item_text\" data-v-0891c71c><div class=\"title\" data-v-0891c71c>被动引流、主动获客</div><div class=\"desc\" data-v-0891c71c>现在全民医保影响下，随着政策的不断完善，医保卡相当于看病就医通行卡，是增加患者流量的钥匙之一</div></div><div class=\"item_img\" data-v-0891c71c><img src=\"" + _imports_3 + "\" alt=\"\" data-v-0891c71c></div></div><div class=\"item\" data-v-0891c71c><div class=\"item_text\" data-v-0891c71c><div class=\"title\" data-v-0891c71c>全流程服务省事放心</div><div class=\"desc\" data-v-0891c71c>提供全流程服务和指导评估，每个流程和步骤详细讲解介绍，让机构了解政策和流程又能放心省事</div></div><div class=\"item_img\" data-v-0891c71c><img src=\"" + _imports_4 + "\" alt=\"\" data-v-0891c71c></div></div><div class=\"item\" data-v-0891c71c><div class=\"item_text\" data-v-0891c71c><div class=\"title\" data-v-0891c71c>降低医疗风险</div><div class=\"desc\" data-v-0891c71c>申请医保定点需要资质齐全，管理规范，系统化更有效减少减低医疗风险</div></div><div class=\"item_img\" data-v-0891c71c><img src=\"" + _imports_5 + "\" alt=\"\" data-v-0891c71c></div></div><div class=\"item\" data-v-0891c71c><div class=\"item_text\" data-v-0891c71c><div class=\"title\" data-v-0891c71c>专业代办更保障</div><div class=\"desc\" data-v-0891c71c>拥有一支专业团队，熟悉各区域政策细节，能够准确评估机构情况，并且大量通过案例</div></div><div class=\"item_img\" data-v-0891c71c><img src=\"" + _imports_6 + "\" alt=\"\" data-v-0891c71c></div></div></div>", 2);
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "other"
}, "或者您也可以致电咨询：400-1601620", -1));
const _hoisted_10 = {
  class: "menu_wrap"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "什么类型机构可以办理医保", -1));
const _hoisted_12 = {
  class: "menu_content container"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title",
  "data-id": "1"
}, "单体/连锁药店", -1));
const _hoisted_14 = [_hoisted_13];
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title",
  "data-id": "2"
}, "普通诊所", -1));
const _hoisted_16 = [_hoisted_15];
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title",
  "data-id": "3"
}, "中医诊所/门诊", -1));
const _hoisted_18 = [_hoisted_17];
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title",
  "data-id": "4"
}, "专科门诊部", -1));
const _hoisted_20 = [_hoisted_19];
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title",
  "data-id": "5"
}, "口腔诊所/门诊", -1));
const _hoisted_22 = [_hoisted_21];
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title",
  "data-id": "6"
}, "综合门诊部", -1));
const _hoisted_24 = [_hoisted_23];
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title",
  "data-id": "7"
}, "卫生服务站", -1));
const _hoisted_26 = [_hoisted_25];
const _hoisted_27 = {
  class: "bottom"
};
const _hoisted_28 = {
  class: "bottom_content"
};
const _hoisted_29 = {
  class: "content_text"
};
const _hoisted_30 = {
  class: "title"
};
const _hoisted_31 = {
  class: "desc"
};
const _hoisted_32 = {
  class: "content_img"
};
const _hoisted_33 = ["src"];
const _hoisted_34 = /*#__PURE__*/_createStaticVNode("<div class=\"process_wrap container\" data-v-0891c71c><div class=\"title\" data-v-0891c71c>医保代办全流程</div><div class=\"desc\" data-v-0891c71c>省时又放心，可为机构提供免费评估服务</div><div class=\"img_wrap\" data-v-0891c71c><img src=\"" + _imports_7 + "\" alt=\"\" data-v-0891c71c></div></div><div class=\"power_wrap container\" data-v-0891c71c><div class=\"title\" data-v-0891c71c>我们的代办实力</div><div class=\"content\" data-v-0891c71c><div class=\"left\" data-v-0891c71c><div class=\"title\" data-v-0891c71c>专业团队</div><div class=\"desc\" data-v-0891c71c>拥有一支专业的申请医保定点的团队，熟悉各个区域政策细则，尝试了解医保申请要求和所有流程。</div></div><div class=\"right\" data-v-0891c71c><div class=\"right_text\" data-v-0891c71c><div class=\"title\" data-v-0891c71c>高通过率</div><div class=\"desc\" data-v-0891c71c>医保申请代办通过率高，成功代办100+医疗机构，包含有门诊部、诊所、口腔类等机构。</div></div><div class=\"right_text\" data-v-0891c71c><div class=\"title\" data-v-0891c71c>专业软件</div><div class=\"desc\" data-v-0891c71c>拥有20多年的医疗软件研发经验，提供一套高标准的医疗门诊管理系统与医保系统无缝对接，满足门诊诊所日常管理经营。</div></div></div></div></div>", 2);
import { ref, onMounted } from 'vue';
import dialogCustomer from '@/components/Customer';
export default {
  __name: 'index',
  setup(__props) {
    const customer = ref(null);
    const fist_menu = ref(1);
    const fist_menu_data = ref([{
      id: 1,
      title: '单体药店、连锁药店',
      desc: '个体药店、单体药店、连锁类型药店均可代办医保，想了解办理医保需要什么条件，点击咨询立即了解。',
      imgSrc: require('@/views/Medicare/img/menu/医保配图.png')
    }, {
      id: 2,
      title: '普通诊所',
      desc: '个体药店、单体药店、连锁类型药店均可代办医保，想了解办理医保需要什么条件，点击咨询立即了解。',
      imgSrc: require('@/views/Medicare/img/menu/诊所.png')
    }, {
      id: 3,
      title: '中医诊所、门诊',
      desc: '个体药店、单体药店、连锁类型药店均可代办医保，想了解办理医保需要什么条件，点击咨询立即了解。',
      imgSrc: require('@/views/Medicare/img/menu/门诊.png')
    }, {
      id: 4,
      title: '专科门诊部',
      desc: '个体药店、单体药店、连锁类型药店均可代办医保，想了解办理医保需要什么条件，点击咨询立即了解。',
      imgSrc: require('@/views/Medicare/img/menu/专科.png')
    }, {
      id: 5,
      title: '口腔诊所、门诊',
      desc: '个体药店、单体药店、连锁类型药店均可代办医保，想了解办理医保需要什么条件，点击咨询立即了解。',
      imgSrc: require('@/views/Medicare/img/menu/口腔.png')
    }, {
      id: 6,
      title: '综合门诊部',
      desc: '个体药店、单体药店、连锁类型药店均可代办医保，想了解办理医保需要什么条件，点击咨询立即了解。',
      imgSrc: require('@/views/Medicare/img/menu/综合.png')
    }, {
      id: 7,
      title: '卫生服务站',
      desc: '个体药店、单体药店、连锁类型药店均可代办医保，想了解办理医保需要什么条件，点击咨询立即了解。',
      imgSrc: require('@/views/Medicare/img/menu/卫生站.png')
    }]);
    const menu_content = ref({});
    const handleFistMenu = function (event) {
      let {
        id
      } = event.target.dataset;
      fist_menu_data.value.forEach(v => {
        if (v.id == id) {
          menu_content.value = v;
        }
      });
      fist_menu.value = id;
    };
    const handleOpen = function () {
      customer.value.openDialog();
    };
    onMounted(() => {
      fist_menu_data.value.forEach(v => {
        if (v.id == fist_menu.value) {
          menu_content.value = v;
        }
      });
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      return _openBlock(), _createElementBlock("article", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_hoisted_5, _hoisted_6, _createVNode(_component_el_button, {
        class: "free_btn",
        onClick: handleOpen
      }, {
        default: _withCtx(() => [_createTextVNode("立即了解")]),
        _: 1
      })])]), _createElementVNode("div", {
        class: "advantage_wrap container"
      }, [_hoisted_7, _createElementVNode("div", {
        class: "button",
        onClick: handleOpen
      }, "立即申请代办"), _hoisted_9]), _createElementVNode("div", _hoisted_10, [_hoisted_11, _createElementVNode("div", _hoisted_12, [_createElementVNode("div", {
        class: "top",
        onClick: handleFistMenu
      }, [_createElementVNode("div", {
        class: _normalizeClass(fist_menu.value == '1' ? 'top_item active' : 'top_item'),
        "data-id": "1"
      }, _hoisted_14, 2), _createElementVNode("div", {
        class: _normalizeClass(fist_menu.value == '2' ? 'top_item active' : 'top_item'),
        "data-id": "2"
      }, _hoisted_16, 2), _createElementVNode("div", {
        class: _normalizeClass(fist_menu.value == '3' ? 'top_item active' : 'top_item'),
        "data-id": "3"
      }, _hoisted_18, 2), _createElementVNode("div", {
        class: _normalizeClass(fist_menu.value == '4' ? 'top_item active' : 'top_item'),
        "data-id": "4"
      }, _hoisted_20, 2), _createElementVNode("div", {
        class: _normalizeClass(fist_menu.value == '5' ? 'top_item active' : 'top_item'),
        "data-id": "5"
      }, _hoisted_22, 2), _createElementVNode("div", {
        class: _normalizeClass(fist_menu.value == '6' ? 'top_item active' : 'top_item'),
        "data-id": "6"
      }, _hoisted_24, 2), _createElementVNode("div", {
        class: _normalizeClass(fist_menu.value == '7' ? 'top_item active' : 'top_item'),
        "data-id": "7"
      }, _hoisted_26, 2)]), _createElementVNode("div", _hoisted_27, [_createElementVNode("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, _toDisplayString(menu_content.value.title), 1), _createElementVNode("div", _hoisted_31, _toDisplayString(menu_content.value.desc), 1), _createElementVNode("div", {
        class: "button",
        onClick: handleOpen
      }, "申请代办")]), _createElementVNode("div", _hoisted_32, [_createElementVNode("img", {
        src: menu_content.value.imgSrc,
        alt: ""
      }, null, 8, _hoisted_33)])])])])]), _hoisted_34, _createVNode(_unref(dialogCustomer), {
        ref_key: "customer",
        ref: customer
      }, null, 512)]);
    };
  }
};